<script>
import {defineComponent} from 'vue'
import api from "@/api/api"
import {formatIsoToCustom} from "@/common/formatToIso";
import {processObjectNullValues} from "@/common/processObjectNullValues";
import TicketLayouts from "@/components/Tickets/layouts/TicketLayouts.vue";

export default defineComponent({
  name: "TicketCategories",
  components: {TicketLayouts},
  data() {
    return {
      categoryParams: {
        name: "",
        enabled: true,
        type_id: null
      },
      isOpenCreateCategory: false,
      ticketCategories: [],
      isLoading: false,
      typeOptions: [],
      sidebarFields: [],
      selectedCategory: {},
      isTypeLoading: false,
      isSidebarLoading: false,
      fields: [
        {key: 'id', label: '№', sortable: true},
        {key: 'date', label: 'Дата', sortable: true},
        {key: 'name', label: 'Название'},
        {key: 'enabled', label: 'Включено',},
        {key: 'username', label: 'Кем создан',},
        // {key: 'description', label: 'Описание',},
        {key: "actions", label: "Действия"}
      ]
    }
  },
  methods: {
    async getTypes() {
      this.isTypeLoading = true;
      try {
        const res = await api.tickets.getListTicketTypes()
        this.typeOptions = res.data?.data.map((type) => ({
          value: type.id,
          text: type.name,
        }))
        this.isTypeLoading = false;
      } catch (e) {
        this.isTypeLoading = false;
      } finally {
        this.isTypeLoading = false;
      }

    },
    async getTicketCategories() {
      this.isLoading = true;
      try {
        const res = await api.tickets.getListTicketCategories({})
        this.ticketCategories = res.data?.data.map((type) => processObjectNullValues({
          id: type.id,
          date: formatIsoToCustom(type.created_at),
          name: type.name,
          enabled: type.enabled ? 'Да' : "Нет",
          username: type.created_by?.username || type.created_by?.email,
          description: type.description,
          _original: type
        }));
        this.isLoading = false;
      } catch (e) {
        console.log(e)
      } finally {
        this.isLoading = false;
      }
    },
    async createCategory() {
      if (!this.categoryParams.name === "") {
        this.$bvToast.toast('Введите название', {
          title: "Валидация",
          variant: "danger",
        })
        return false
      }
      // if (!this.categoryParams.type_id) {
      //   this.$bvToast.toast('Выберите тип', {
      //     title: "Валидация",
      //     variant: "danger",
      //   })
      //   return false
      // }
      try {
        const res = await api.tickets.createTicketCategory(this.categoryParams)
        const newCategory = res.data?.data

        const formattedCategory = processObjectNullValues({
          id: newCategory.id,
          date: formatIsoToCustom(newCategory.created_at),
          name: newCategory.name,
          enabled: newCategory.enabled ? 'Да' : "Нет",
          username: newCategory.created_by?.username || newCategory.created_by?.email,
          description: newCategory.description,
          _original: newCategory
        })

        this.ticketCategories.push(formattedCategory)
        this.$bvModal.hide('create-categories')
        this.isOpenCreateCategory = false
        this.categoryParams.name = ""
        this.categoryParams.enabled = false
      } catch (e) {
        console.log(e)
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async deleteCategory(category) {
      try {
        if (category && category.id) {
          await api.tickets.deleteTicketCategory(category?.id)
        }
        this.ticketCategories = this.ticketCategories.filter(item => item.id !== category.id)
      } catch (e) {
        console.log('deleting category error: ', e)
        this.$bvToast.toast(e.response.message || e.response.data.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      }
    },
    async openEditSidebar(item) {
      await this.getTypes()
      this.sidebarFields = [
        {
          key: 'name',
          label: 'Название',
          type: 'text',
          placeholder: 'Введите название',
          required: true
        },
        {
          key: 'enabled',
          label: 'Включено',
          type: 'checkbox',
          default: true
        }
      ]
      this.selectedCategory = {
        id: item.id,
        name: item._original?.name || item.name,
        type_id: item._original?.type_id,
        description: item._original?.description || '',
        enabled: item._original?.enabled ?? true
      }
      this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
    },
    async handleSaveCategory(formData) {
      this.isSidebarLoading = true
      try {
        const res = await api.tickets.updateTicketCategory(this.selectedCategory.id, {
          name: formData.name,
          enabled: formData.enabled
        })
        const updatedCategory = res.data?.data || formData
        const index = this.ticketCategories.findIndex(cat => cat.id === formData.id)
        if (index !== -1) {
          const oldItem = this.ticketCategories[index]
          this.$set(this.ticketCategories, index, processObjectNullValues({
            id: updatedCategory.id,
            date: oldItem.date,
            name: updatedCategory.name,
            enabled: updatedCategory.enabled ? 'Да' : 'Нет',
            username: oldItem.username,
            description: updatedCategory.description,
            _original: updatedCategory
          }))

        }
        this.$bvToast.toast('Категория успешно обновлена', {
          title: "Успех",
          variant: "success",
        })
        this.$root.$emit('bv::toggle::collapse', 'sidebar-right')
        this.selectedCategory = null
      } catch (e) {
        console.log('updating category error: ', e)
        this.$bvToast.toast(e.response?.message || e.response?.data?.message || 'Произошла ошибка', {
          title: "Ошибка сервера",
          variant: "danger",
        })
      } finally {
        this.isSidebarLoading = false
      }
    }
  },
  watch: {
    isOpenCreateCategory() {
      if (this.isOpenCreateCategory === true) {
        this.getTypes()
      }
    }
  },
  mounted() {
    this.getTicketCategories()
  }
})
</script>

<template>
  <TicketLayouts
      title="Редактирование Категории"
      :sidebar-item="selectedCategory"
      :sidebar-fields="sidebarFields"
      :sidebar-loading="isSidebarLoading"
      @sidebar-save="handleSaveCategory"
  >
    <Breadcrumbs main="Tickets" title="Категории"/>
    <div class="d-flex justify-content-end">
      <b-button v-b-modal.create-categories @click="isOpenCreateCategory = true" variant="success">
        Создать
      </b-button>
    </div>
    <div class="container-fluid">
      <b-table
          responsive
          show-empty
          stacked="md"
          :items="ticketCategories"
          striped
          bordered
          :current-page=1
          :per-page=10
          :fields="fields"
      >
        <template #cell(description)="{item}">
          <p :class="item.description === '-' ? 'text-center' : 'text-muted'">
            {{ item.description }}
          </p>
        </template>
        <template #cell(actions)="{item}">
          <b-button
              class="mr-2"
              variant="primary"
              size="sm"
              @click="openEditSidebar(item)"
          >
            <i class="fas fa-edit"></i> Редактировать
          </b-button>
          <b-button
              variant="danger"
              size="sm"
              @click="deleteCategory(item)"
          >
            <i class="fas fa-trash"></i> Удалить
          </b-button>
        </template>
      </b-table>
    </div>
    <b-modal id="create-categories" title="Создать категорию" hide-footer>
      <div v-if="isTypeLoading" class="d-flex justify-content-center align-items-center h-100">
        <b-spinner></b-spinner>
      </div>
      <b-form @submit.prevent="createCategory" v-else>
        <b-form-input placeholder="Название" v-model="categoryParams.name"/>
<!--        <b-form-select v-model="categoryParams.type_id" :options="typeOptions" class="mt-3"></b-form-select>-->
        <div class="mt-3 d-flex spacing gap-1">
          <b-form-checkbox v-model="categoryParams.enabled" :value="categoryParams.enabled"></b-form-checkbox>
          <p>Включено</p>
        </div>
        <b-button class="mt-3 w-100" type="submit">Создать</b-button>
      </b-form>
    </b-modal>
  </TicketLayouts>
</template>

<style scoped lang="scss">

</style>